const SET_DIRECTIONS = 'SET_DIRECTIONS';
const SET_DIRECTION_POLES = 'SET_DIRECTION_POLES';
const SET_SITES = 'SET_SITES';
const SET_FUNCTIONS = 'SET_FUNCTIONS';
const SET_SKILLS = 'SET_SKILLS';
const SET_PAGE = 'SET_PAGE';

const REDUCER_ACTIONS = {
  SET_DIRECTIONS,
  SET_DIRECTION_POLES,
  SET_SITES,
  SET_FUNCTIONS,
  SET_SKILLS,
  SET_PAGE,
}
export default REDUCER_ACTIONS;
